import React from "react";
import Box from "components/common/Box";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ProductCardIcon from "components/allInOneDashboard/ProductCardIcon";

const LockedProductCard = ({ product, onClick }) => (
  <Box
    onClick={onClick}
    sx={{
      position: "relative",
      height: "100%",
      minHeight: { xs: 280, md: 300 },
      display: "flex",
      flexDirection: "column",
      borderRadius: "39px",
      border: "1.6px solid #E5E7EB",
      bgcolor: "rgba(255,255,255,0.4)",
      overflow: "hidden",
      cursor: "pointer",
      backdropFilter: "blur(16px)",
      WebkitBackdropFilter: "blur(16px)",
      transition: "transform 0.2s, box-shadow 0.2s",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      },
    }}
  >
    <Box
      sx={{
        position: "absolute",
        left: -2,
        top: -2,
        width: "100%",
        height: "100%",
        background: product.gradient,
        filter: "blur(19px)",
        pointerEvents: "none",
      }}
    />
    <Stack
      sx={{
        position: "relative",
        zIndex: 1,
        p: { xs: 2.5, md: 3 },
        height: "100%",
        flex: 1,
      }}
    >
      <Text
        sx={{
          fontSize: "clamp(1.25rem, 1.1rem + 0.45vw, 1.75rem)",
          fontWeight: 700,
          color: "#111827",
          lineHeight: 1.2,
          pr: "28%",
        }}
      >
        {product.name?.replace(/^Jarvis\s+/i, "") || product.name}
      </Text>
      <Text
        sx={{
          mt: 1.5,
          fontSize: "clamp(0.8125rem, 0.75rem + 0.2vw, 1rem)",
          color: "#111827",
          maxWidth: "72%",
          lineHeight: 1.4,
          fontWeight: 400,
        }}
      >
        {product.lockedSubtitle || product.subtitle}
      </Text>
      <ProductCardIcon
        product={product}
        sx={{
          position: "absolute",
          right: { xs: -61, md: -14 },
          bottom: { xs: -14, md: -18 },
          width: "clamp(200px, 55%, 257px)",
          height: "clamp(200px, 52%, 250px)",
          objectFit: "contain",
          pointerEvents: "none",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          left: { xs: 20, md: 28 },
          bottom: { xs: 24, md: 32 },
          width: 64,
          height: 64,
          borderRadius: "999px",
          border: "1.6px solid #F1F1F1",
          bgcolor: "rgba(255,255,255,0.6)",
          backdropFilter: "blur(11px)",
          WebkitBackdropFilter: "blur(11px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
        }}
      >
        <ArrowForwardIcon sx={{ fontSize: 28, color: "#111827" }} />
      </Box>
    </Stack>
  </Box>
);

export default LockedProductCard;
